export default "__VITE_ASSET__1db7df63__"